import { useState, useEffect } from 'react'
import useReviewersActions from './useReviewersActions'

export default function useReviewersStatistics() {
  const { getReviewersStatistics } = useReviewersActions()
  const [statistics, setStatistics] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  async function fetchStatistics() {
    try {
      setIsLoading(true)
      const data = await getReviewersStatistics()
      setStatistics(data)
    } catch (error) {
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStatistics()
  }, [])

  return { statistics, isLoading }
}
